import DownloadIcon from "../../assets/header/download.svg?react";
import GooglePlayIcon from "../../assets/header/google-play.svg?react";
import AndroidIcon from "../../assets/header/android.svg?react";
import AppleIcon from "../../assets/header/apple.svg?react";
import { stylesText, dropDownStylesText } from "../styles";
import { stylesBg, stylesButton } from "./styles";
import { useStoreState } from "../store/useStore";
import { useTranslations } from "use-intl";
import styles from "./index.module.scss";

const ApplicationPopper = () => {
  const { theme } = useStoreState();

  const t = useTranslations("header");

  return (
    <div
      className={`h-[64px] flex items-center ml-[24px] cursor-pointer group relative max-[600px]:hidden ${styles["download-container"]}`}
    >
      <DownloadIcon
        className={stylesText({
          mode: theme
        })}
      />
      <div
        className={`${stylesBg({
          mode: "light"
        })} shadow-[0_2px_20px_rgba(0,0,0,.12)] w-[268px] ${styles["download-hover-animate"]}`}
      >
        <div
          className={`${dropDownStylesText({
            mode: "light"
          })} tracking-[-0.4px] font-medium text-[14px]`}
        >
          {t("download&Trade")}
        </div>
        <img
          className="w-[140px] h-[140px] my-[16px]"
          src="https://s2.blockfin.com/frontend-images/blockfin-qrcode.png"
          alt=""
        />
        <a
          className={stylesButton({ mode: "light" })}
          href="https://play.google.com/store/apps/details?id=com.blockfin.android"
          target="_blank"
          rel="noreferrer"
        >
          <GooglePlayIcon
            className={`mr-[16px] ${dropDownStylesText({
              mode: "light"
            })}`}
          />
          <div
            className={`flex flex-col ${dropDownStylesText({
              mode: "light"
            })}`}
          >
            <span className="text-label text-[12px]">{t("downloadFrom")}</span>
            <span>Google Play</span>
          </div>
        </a>
        <a
          className={stylesButton({ mode: "light" })}
          href="https://blockfin.com/download/blockfin.apk"
          target="_blank"
          rel="noreferrer"
        >
          <AndroidIcon
            className={`mr-[16px] ${dropDownStylesText({
              mode: "light"
            })}`}
          />
          <div
            className={`flex flex-col ${dropDownStylesText({
              mode: "light"
            })}`}
          >
            <span className="text-label text-[12px]">{t("downloadFor")}</span>
            <span>Android</span>
          </div>
        </a>
        <a
          className={stylesButton({ mode: "light" })}
          href="https://apps.apple.com/app/blockfin-com/id6744881448"
          target="_blank"
          rel="noreferrer"
        >
          <AppleIcon
            className={`mr-[16px] ${dropDownStylesText({
              mode: "light"
            })}`}
          />
          <div
            className={`flex flex-col ${dropDownStylesText({
              mode: "light"
            })}`}
          >
            <span className="text-label text-[12px]">{t("downloadFrom")}</span>
            <span>App Store</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ApplicationPopper;
